import { TYPE } from './modalLandingCommercial.types';

export const showModalCommercial = payload => ({// node home
  type: TYPE.SHOW_MODAL_COMMERCIAL,
  payload,
});

export const setOfferSelector = payload => ({// node home
  type: TYPE.SET_OFFER_SELECTOR,
  payload,
});

export const setPaymentLink = payload => ({
  type: TYPE.SET_PAYMENT_LINK,
  payload,
});

export const setParamPaymentIsActive = payload => ({
  type: TYPE.SET_PARAM_PAYMENT_IS_ACTIVE,
  payload,
});